<div class="gridItemChildModule w-100 h-100 d-flex flex-column">
    <!-- Place main body content here -->
    <!-- Sample Search -->
    <div class="w-75 mx-auto my-2 search-box live-search" [hidden]="!showFilter">
        <input type="search" class="form-control"
            autocomplete="off"
            [(ngModel)]="filterValue"
            (ngModelChangeDebounced)="applyFilter()"
            [ngModelChangeDebounceTime]="500"
            ng-trim="true"
            placeholder="Search..."
            cvLocalizedPlaceholder
            [langSection]="'Subscriptions_Management'"
            [langKey]="'Search'"
        />
        <span class="clear-input" role="button" tabindex="0"
            [hidden]="filterValue.length === 0"
            (click)="clearFilter()">
        </span>
    </div>
    <!-- Sample ag-grid.  Remove if unneeded. -->
    <ag-grid-angular #ngTemplateGrid *ngIf="gridOptions != null" class="ag-theme-balham flex-fill" [gridOptions]="gridOptions"></ag-grid-angular>
</div>
